import { unwrapResult } from '@reduxjs/toolkit';
import { cloneDeep, isEmpty } from 'lodash';
import { slices, useAppDispatch } from 'src/redux';
import { useSnackBar } from '../use-snackbar';
import { onTapTapCustomerTransactionInfoChangeViaInternal } from 'src/redux/slices/taptap-customer';
import { GetTransactionsViaTransactionNoResponse } from 'src/types';
import { useState } from 'react';

const { actions: transactionActions } = slices.transaction;

export const useTransactionDelete = () => {
  const dispatch = useAppDispatch();
  const snackBar = useSnackBar();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onDeleteWholeTransaction = async (
    void_reason: string | undefined,
    transactionInfo: GetTransactionsViaTransactionNoResponse,
    onSuccessCallback: () => void
  ) => {
    try {
      setIsLoading(true);
      const response = unwrapResult(
        await dispatch(
          transactionActions.deleteTransactionViaTransactionNo({
            transaction_no: transactionInfo?.transaction_no || '',
            void_reason
          })
        )
      );
      if (response?.success && !isEmpty(response?.originalData)) {
        snackBar.show({
          message: 'Transaction Successfully Deleted',
          severity: 'info'
        });

        const transactionVoidedDataForTapTap = cloneDeep(transactionInfo);
        if (transactionVoidedDataForTapTap) {
          transactionVoidedDataForTapTap.total_price = 0; // 0 kasi wala eh deleted na :(
          transactionVoidedDataForTapTap.sub_total_price = 0; // 0 kasi wala eh deleted na :(
          onTapTapCustomerTransactionInfoChangeViaInternal(
            transactionVoidedDataForTapTap
          );
        }

        if (onSuccessCallback) {
          await onSuccessCallback();
        }
      } else {
        snackBar.show({
          message: 'Deleting of Transaction Failed',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    onDeleteWholeTransaction
  };
};
